import "@fontsource/oswald";
import HeaderBlue from '../../components/HeaderBlue';
import FooterBlue from '../../components/FooterBlue';

const CarrierBenefits = () => {
    return (
        <div className="bg-gray-100 text-dark min-h-screen flex flex-col">
            <HeaderBlue />

            {/* Hero Section */}
            <section
                className="w-full py-60 relative bg-cover bg-top px-3"
                style={{
                    backgroundImage: "url('./assets/employerbenefits.webp')"
                }}
            >
                <div className="absolute inset-0 bg-gradient-to-r from-black/80 to-white/10 z-0"></div>
                <div className="md:px-40 relative z-10">
                    <h2 className="text-white text-6xl font-bold text-shadow font-oswald">CARRIER BENEFITS</h2>
                    <p className="text-white text-xl font-semibold font-oswald mt-2">
                        {/* Discover the advantages of partnering with us to find <br />and hire top drivers for their company. */}
                    </p>
                </div>
            </section>

            {/* Main Content */}
            <main className="container max-w-7xl mx-auto px-5 mt-10 flex-grow">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
                    {[
                        {
                            icon: 'fas fa-users',
                            title: 'Access to Top Talent',
                            desc: 'Connect with thousands of verified drivers, including experienced professionals and new CDL holders, ready to join your team.'
                        },
                        {
                            icon: 'fas fa-tachometer-alt',
                            title: 'Streamlined Hiring',
                            desc: 'Use our advanced dashboard to filter candidates by experience, endorsements, and route preferences, saving you time and effort.'
                        },
                        {
                            icon: 'fas fa-handshake',
                            title: 'Dedicated Support',
                            desc: 'Premium package subscribers receive a dedicated account manager to assist with hiring needs and optimize your recruitment process.'
                        },
                        {
                            icon: 'fas fa-bullhorn',
                            title: 'Enhanced Visibility',
                            desc: 'Showcase your company to drivers through our platform, increasing your brand’s reach and attracting high-quality applicants.'
                        },
                        {
                            icon: 'fas fa-user-shield',
                            title: 'Retention Tools',
                            desc: 'Access resources and strategies to improve driver retention, including feedback tools and engagement programs to build a loyal workforce.'
                        },
                        {
                            icon: 'fas fa-chart-line',
                            title: 'Data-Driven Insights',
                            desc: 'Gain actionable analytics on your recruitment campaigns and driver engagement to make smarter, more effective hiring decisions.'
                        }
                    ].map((benefit, index) => (
                        <div
                            key={index}
                            className="bg-light rounded-xl shadow-[0_4px_16px_rgba(184,14,11,0.10)] border border-border p-6 flex flex-col hover:shadow-[0_8px_32px_rgba(184,14,11,0.15)] hover:-translate-y-1.5 hover:scale-[1.03] transition"
                        >
                            <i className={`${benefit.icon} text-4xl text-deep-red mb-4`}></i>
                            <div className="text-xl font-bold  mb-3 text-balck">{benefit.title}</div>
                            <div className="text-dark text-base leading-relaxed">{benefit.desc}</div>
                        </div>
                    ))}
                </div>
            </main>
            <FooterBlue />
        </div>
    );
};

export default CarrierBenefits;
